import { scrollToElement } from '@/scopes/common/infrastructure/dom/scrollToElement'
import { useEffect } from 'react'

export function useScrollToSection(loading: boolean, id: string) {
  useEffect(() => {
    if (!loading) {
      scrollToElement(`#${id}`)
    }
  }, [loading])
}
